import axios from 'axios';

const API_PREFIX = 'api/fe/landings';

function getInstitutionsData(domain = '') {
  const url = `${domain}/${API_PREFIX}/real-estate/institutions`;
  const options = {};

  return axios.get(url, options);
}

function getInstitutionData(domain = '', path, locale) {
  const url = `${domain}/${API_PREFIX}/real-estate/institutions/${path}`;
  const options = {
    params: { locale }
  };

  return axios.get(url, options);
}

export { getInstitutionsData, getInstitutionData };
